import React, { Component, PropTypes } from 'react';
import { logout, getAuthData } from 'utils/MemberUtils';
import connect from 'connect-alt';

@connect('Member')
class MemberWidget extends Component {
  static propTypes = {
    MemberStore: PropTypes.object.isRequired
  };

  static contextTypes = {
    flux: PropTypes.object.isRequired
  }

  _onLogout() {
    logout();
    location.href = '/';
  }

  render() {
    const {
      MemberStore: {
        login = false
      } = {}
    } = this.props;

    const authData = getAuthData();

    if (login || authData) {
      const {
        member: {
          firstname,
          username
        } = {}
      } = authData;

      return (
        <div className="MemberWidget">
          <span>Welcome, {firstname ? firstname : username}! </span>
          <a href='/profile'>Manage Account </a> <a onClick={() => this._onLogout()}>Log Out</a>
        </div>
      );
    }

    return (
      <div className="MemberWidget">
        <a href='/register'>Create Account </a>
        <a href='/login'>Log In</a>
      </div>
    );
  }
}

export default MemberWidget;



// WEBPACK FOOTER //
// ./app/components/membership/MemberWidget.js